import type { AiEndpoint, AiFeature, AiFeatureEndpointsDto } from "../../../autogen/bff-api";

export const aiFeaturesOff = (allowed: AiEndpoint[], routes: AiFeatureEndpointsDto[]): AiFeature[] =>
  routes.filter((route) => !route.endpoints.some((endpoint) => allowed.includes(endpoint))).map((route) => route.feature);
